// extracted by mini-css-extract-plugin
module.exports = {"empty":"styles_empty__3RYud"};